import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { withRouter } from '@bibliocommons/utils-routing';
import { bindAll } from '@bibliocommons/utils-react';
import { sendAnalyticsEvents } from '@bibliocommons/utils-analytics';
import { shelvesEventComposer } from '@bibliocommons/analytics-event-composers';
import { routerShape } from '@bibliocommons/bc-prop-types';
import Context from '@bibliocommons/context';

import './ShelfFindAvailableTitlesButton.scss';

export class ShelfFindAvailableTitlesButton extends React.PureComponent {
  constructor(props) {
    super(props);
    bindAll(this);
  }

  getUrl() {
    const { router, currentShelfName } = this.props;
    return router.createHref({
      pathname: '/v2/search',
      query: {
        ...router.query,
        origin: 'shelves-available-titles',
        shelf: currentShelfName,
        f_STATUS: '_online_|_physical_',
        f_IS_PRIVATE: undefined,
        f_I_OWN_THIS: undefined,
        f_TAG_PERSONAL: undefined,
        page: undefined,
        sort: undefined
      }
    });
  }

  handleShelfAvailabilitySearch() {
    const { currentShelfName, shelfCount } = this.props;
    sendAnalyticsEvents(shelvesEventComposer.composeShelfAvailabilitySearchEvent(shelfCount, currentShelfName));
  }

  render() {
    return (
      <a
        className="cp-shelf-find-available-titles-button btn"
        href={this.getUrl()}
        onClick={this.handleShelfAvailabilitySearch}
        data-key="find-available-titles-button"
      >
        <FormattedMessage id="find_available_titles_button" />
      </a>
    );
  }
}

ShelfFindAvailableTitlesButton.propTypes = {
  currentShelfName: PropTypes.string.isRequired,
  shelfCount: PropTypes.number.isRequired,
  router: routerShape.isRequired
};

export default withRouter(ShelfFindAvailableTitlesButton);

ShelfFindAvailableTitlesButton.contextType = Context;
